import ReportTable from '../../../../../components/Grid/ReportTable';

type FiscalTableProps = { cupons: any[]; totalPorCfop: any[]; totalPorPeriodo: any[]; };

export default function FiscalTable({ cupons, totalPorCfop, totalPorPeriodo }: FiscalTableProps) {
  if (!cupons || cupons.length <= 1) return <ReportTable model={cupons} columnCount={9} />;
  return <div className="relatorios-fiscal-tables">
    <ReportTable model={cupons} columnCount={9} title="Cupons emitidos" />
    {totalPorCfop && totalPorCfop.length > 1 && <ReportTable model={totalPorCfop} columnCount={3} title="Total geral por CFOP" />}
    {totalPorPeriodo && totalPorPeriodo.length > 1 && <ReportTable model={totalPorPeriodo} columnCount={5} title="Total do período" rowClassName={row => row[1] === 'Cancelada' ? 'relatorios-row-cancelled' : ''} />}
  </div>;
}
